import { component$ } from "@builder.io/qwik";

interface PriceDisplayProps {
  price: number;
  currency: string;
  originalPrice?: number | null;
  size?: "sm" | "md" | "lg";
}

export const PriceDisplay = component$<PriceDisplayProps>(
  ({ price, currency, originalPrice, size = "md" }) => {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
    });

    const sizeClasses = {
      sm: "text-lg",
      md: "text-2xl",
      lg: "text-4xl",
    };

    return (
      <div class="flex flex-col items-center gap-1">
        <div class="flex flex-col items-center gap-2">
          {originalPrice && originalPrice > price && (
            <span
              class={`text-tertiary line-through ${size === "lg" ? "text-2xl" : "text-lg"}`}
            >
              {formatter.format(originalPrice / 100)}
            </span>
          )}
          <span class={`font-heading font-semibold ${sizeClasses[size]}`}>
            {formatter.format(price / 100)}
          </span>
        </div>
      </div>
    );
  },
);
